import { buildApiUrl } from "../helpers/base_url";

export interface SubscriptionPlanFeature {
  key: string;
  value: string;
}

export interface SubscriptionPlan {
  id: number;
  name: string;
  description: string;
  price: number;
  durationInDays: number;
  planTier: "STARTER" | "PRO" | "ELITE";
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  features: SubscriptionPlanFeature[];
}

export interface SubscriptionPlansResponse {
  status: number;
  message: string;
  data: SubscriptionPlan[];
  timestamp: string | null;
  success: boolean;
  errors: any;
  path: string | null;
  method: string | null;
}

export const getSubscriptionPlans = async (): Promise<SubscriptionPlan[]> => {
  const accessToken = localStorage.getItem("accessToken");
  
  const response = await fetch(buildApiUrl("/api/subscription-plans"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
    },
  });

  const data: SubscriptionPlansResponse = await response.json().catch(() => null);

  if (!response.ok) {
    const errorMessage =
      data?.message ||
      (typeof data === "string" ? data : "Failed to fetch subscription plans");
    throw new Error(errorMessage);
  }

  return data?.data || [];
};

